import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LoisirsHero } from '../components/loisirs/LoisirsHero';
import { LoisirsJourney } from '../components/loisirs/LoisirsJourney';
import { LoisirsChallenge } from '../components/loisirs/LoisirsChallenge';
import { LoisirsSolution } from '../components/loisirs/LoisirsSolution';
import { LoisirsReplace } from '../components/loisirs/LoisirsReplace';
import { trackEvent } from '../utils/analytics';
export function Loisirs() {
  useEffect(() => {
    trackEvent('Page Viewed', {
      page: 'Loisirs'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8770" data-mp="1u47csi15jg0d">
      <Header data-id="element-8771" data-mp="1z41xu4y8xbdi" />
      <main className="pt-[120px]" data-id="element-8772" data-mp="1z4lab654n7k5">
        <section className="pt-14 pb-24 px-6 overflow-hidden bg-[#FCFCFE]" data-id="element-8773" data-mp="1z5muq18196ej">
          <LoisirsHero data-id="element-8774" data-mp="35j2nxu0lazc6" />
        </section>
        <section className="py-24 lg:py-28 px-6 bg-white border-t border-[#EEF0F4]" data-id="element-8775" data-mp="35m8bv5xhfv6b">
          <LoisirsChallenge data-id="element-8776" data-mp="3ahdxs4qvx9ue" />
        </section>
        <section className="py-24 lg:py-28 px-6 bg-[#FCFCFE] border-t border-[#EEF0F4]" data-id="element-8777" data-mp="324nur7ficd1z">
          <LoisirsSolution data-id="element-8778" data-mp="2y2tw14ovhj4g" />
        </section>
        <section className="py-24 lg:py-28 px-6 bg-white border-t border-[#EEF0F4]" data-id="element-8779" data-mp="2y3vhm33ilo0f">
          <LoisirsJourney data-id="element-8780" data-mp="2t2em6n3sutr8" />
        </section>
        <section className="py-24 lg:py-28 px-6 bg-[#FCFCFE] border-t border-[#EEF0F4]" data-id="element-8781" data-mp="2t5ajqabqjgf5">
          <LoisirsReplace data-id="element-8782" data-mp="2o6h52ekppjde" />
        </section>
      </main>
      <Footer data-id="element-8783" data-mp="2j6bkficv0x4t" />
    </div>;
}